import { memo } from 'react';
import { MSDIcon } from '../../../misc/icons/Icons';
import Breadcrumb from '../../navigation/partials/Breadcrumb';
import Menu from '../../navigation/partials/Menu';

const SidebarWrapper = ({
	children, title = '', hiddenMobileTitlePartTwo = '', hideBreadcrumb = false, showLogo = false, showNavigation = false, hideForMobile = false, activeTree, customTree,
}) => (
	<div className={`${hideForMobile ? 'hidden lg:' : ''}flex lg:fixed lg:bottom-0 lg:z-20 lg:top-24 print:hidden`}>
		<div className="flex flex-col flex-1 w-full lg:w-88 bg-oly-blue-default">
			<div className="flex-1 h-0 overflow-y-auto">
				{!hideBreadcrumb && <div className="hidden lg:block"><Breadcrumb activeTree={activeTree} customTree={customTree} /></div>}
				{showNavigation && <Menu activeTree={activeTree} />}
				<div className={`flex flex-col items-center px-12 lg:items-start ${!hideBreadcrumb ? '' : 'mt-8 lg:mt-24'}`}>
					{showLogo && <MSDIcon className="text-white w-42 h-14 lg:w-60 lg:h-20 lg:mb-4" />}
					{title && (
						<h1 className="text-[1.5625rem] lg:text-[2.1875rem] text-white leading-8 lg:leading-10 py-8">
							{title}
							{hiddenMobileTitlePartTwo && (
								<span className="hidden lg:flex">
									{' '}
									{hiddenMobileTitlePartTwo}
								</span>
							)}
						</h1>
					)}
					{children}
				</div>
			</div>
		</div>
	</div>
);

// TODO: Wann immer memo?
export default memo(SidebarWrapper);
